import { ProductActions } from "./ProductActions";
import { ProductBadge } from "./ProductBadge";

export function ProductImage({ product }) {
  return (
    <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] bg-neutral-100">
      <img
        src={product.image}
        alt={product.title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105 group-hover:opacity-0"
      />

      <img
        src={product.hoverImage}
        alt={`${product.title} alternate view`}
        loading="lazy"
        className="absolute inset-0 h-full w-full scale-105 object-cover opacity-0 transition duration-700 group-hover:scale-100 group-hover:opacity-100"
      />

      <div className="absolute left-4 top-4 z-20 flex flex-col gap-2">
        {product.isSoldOut ? (
          <ProductBadge type="soldOut">Sold Out</ProductBadge>
        ) : null}

        {!product.isSoldOut && product.isNew ? (
          <ProductBadge type="new">New</ProductBadge>
        ) : null}

        {!product.isSoldOut && product.isBestSeller ? (
          <ProductBadge type="bestSeller">Best Seller</ProductBadge>
        ) : null}

        {!product.isSoldOut && product.discount ? (
          <ProductBadge type="sale">Sale</ProductBadge>
        ) : null}
      </div>

      <ProductActions product={product} />
    </div>
  );
}